import * as ISOCountries from 'i18n-iso-countries';
import cs from 'i18n-iso-countries/langs/cs.json';
import de from 'i18n-iso-countries/langs/de.json';
import el from 'i18n-iso-countries/langs/el.json';
import en from 'i18n-iso-countries/langs/en.json';
import es from 'i18n-iso-countries/langs/es.json';
import fi from 'i18n-iso-countries/langs/fi.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import it from 'i18n-iso-countries/langs/it.json';
import nl from 'i18n-iso-countries/langs/nl.json';
import nn from 'i18n-iso-countries/langs/nn.json';
import sv from 'i18n-iso-countries/langs/sv.json';
import pl from 'i18n-iso-countries/langs/pl.json';
import pt from 'i18n-iso-countries/langs/pt.json';

const countries = {
  cs,
  de,
  el,
  en: {
    ...en,
    countries: {
      ...en.countries,
      US: 'United States',
    },
  },
  es,
  fi,
  fr,
  it,
  nl,
  nn: {
    ...nn,
    countries: {
      ...nn.countries,
      NO: 'Norge',
    },
  },
  sv,
  pl,
  pt,
};

// In i18n-iso-countries, the code for Norway is NN instead of NO so we need to have a mapper
const mappedCountries = {
  cs: 'cs',
  de: 'de',
  el: 'el',
  en: 'en',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  nl: 'nl',
  nn: 'no',
  sv: 'sv',
  pl: 'pl',
  pt: 'pt',
};

for (const countryKey in countries) {
  ISOCountries.registerLocale(countries[countryKey]);
}

const allCountriesProgrammaticTranslations = Object.keys(countries).reduce(
  (acc, countryKey) => ({
    ...acc,
    [mappedCountries[countryKey]]: {
      'products-fe': {
        countries: ISOCountries.getNames(countryKey),
      },
      fields: {
        common: {
          country: {
            options: ISOCountries.getNames(countryKey),
          },
        },
        enm: {
          country: {
            options: ISOCountries.getNames(countryKey),
          },
        },
      },
    },
  }),
  {},
);

export default allCountriesProgrammaticTranslations;
